import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { buttonStyle, commonErrorStyleText, errorTextStyle, titleStyle } from '../../../utils/commonCSS'
import CustomTextField from '../../CustomTextField'
import { Add, AddCircleOutline, Circle, Delete } from '@mui/icons-material'
import { headingBlue, red } from '../../../assets/colors'
import { errorStyleText } from '../../formStyle'
import { addNewLeadTemplate, getAllLeadTemplates } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import Loader from '../../Loader'

const LeadTemplates = (props) => {

    const [isAddTemplate, setIsAddTemplate] = useState(false)
    const [templateName, setTemplateName] = useState('')
    const [templateNameError, setTemplateNameError] = useState('')
    const [fields, setFields] = useState([''])
    const [fieldErrorIndex, setFieldErrorIndex] = useState([])
    const [addApiError, setAddApiError] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [leadTemplates, setLeadTemplates] = useState([])
    const [apiError, setApiError] = useState('')

    const addNewField = () => {
        setFields((prev) => [...prev, ''])
    }
    
    const updateField = (index, value) => {
        let fieldValues = fields
        fieldValues[index] = value
        setFields((prev) => [...fieldValues])
    }

    const deleteField = (index) => {
        let fieldValues = fields
        fieldValues.splice(index, 1)
        setFields(() => [...fieldValues])
    }

    const AddNewTemplate = () => {
        setIsLoading(true)
        let isValid = true

        if(!templateName || templateName === ''){
            setTemplateNameError('Template Name is Required')
            isValid = false
        } else {
            setTemplateName('')
        }

        fields.map((field, index) =>  {
            if( field === ''){
                setFieldErrorIndex((prev) => [...prev, index])
                isValid = false
            }
        })

        if( isValid){
            let options = {
                url: addNewLeadTemplate,
                method: 'POST',
                payload: {
                    name: templateName,
                    fields: fields
                },
                headers: {
                    headers: {
                        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                    }
                }
            }

            HttpService(options).then(resp => {
                console.log('Lead template added successfully.')
                setIsLoading(false)
                setIsAddTemplate(false)
            }).catch(err => {
                setAddApiError(err?.response?.data?.message ? err?.response?.data?.message : 'Error in Adding New Template. Please Contact Support')
                setIsLoading(false)
            })
        } else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(!isAddTemplate){
            setIsLoading(true)
            setApiError('')
            let options = {
                url: getAllLeadTemplates,
                method: 'GET',
                params: {},
                headers: {
                    Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
                }
            }
            HttpService(options).then(resp => {
                console.log("Resp:    ", resp?.data?.data)
                setLeadTemplates(resp?.data?.data)
                setIsLoading(false)
            }).catch(err => {
                console.log('Error in fetching the lead templates: ', err)
                setApiError('Error in fetching the lead templates.')
                setIsLoading(false)
            })
        }
    }, [isAddTemplate])

  return (
    <>
        <Dialog maxWidth= 'sm' fullWidth open={props.dialogStatus} onClose={() => props.updateDialogStatus()}>
            <DialogTitle style={titleStyle}>
                Lead Templates
            </DialogTitle>
            <DialogContent>
                {isLoading && <Loader></Loader>}
                <Box style={{width: '97%', display: 'flex', justifyContent: 'flex-end', padding: '0.5rem'}}>
                    {isAddTemplate ? 
                    <Button style={buttonStyle}
                        onClick={() => setIsAddTemplate(false)}
                    >Templates</Button>
                    : 
                    <Button style={buttonStyle}
                        onClick={() => setIsAddTemplate(true)}
                    > Add New Template</Button>}
                </Box>
                {isAddTemplate ?
                    <Box style={{marginTop: '1rem', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
                        <CustomTextField placeHolder='Template Name' value={templateName} setFunc={(value) => setTemplateName(() => value)}></CustomTextField>
                        <Typography style={commonErrorStyleText}>{templateNameError}</Typography>
                        <Paper style={{marginTop: '0.5rem', padding: '0.5rem', width: '100%'}}>
                            <Typography>Fields</Typography>
                            <Box style={{display: 'flex', justifyContent: 'center'}}>
                                <Grid container spacing={1}>
                                    {fields.map((row, index) => (
                                        <>
                                            <Grid item xs={8} sm={8}>
                                                <CustomTextField regular={true} indexRequired = {true} id={index} value={row} setFunc={updateField}></CustomTextField>
                                                { fieldErrorIndex.includes(index) ? 
                                                    <Typography style={commonErrorStyleText}>Field cannot be empty</Typography>:
                                                    <></>    
                                                }
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                {fields.length > 1 ?
                                                <Delete sx={{color: red}}
                                                onClick={() => {
                                                    deleteField(index)
                                                }}
                                                ></Delete> : <></>} 
                                                {index === fields?.length - 1 ? 
                                                    <AddCircleOutline style={{color: headingBlue}}
                                                        onClick={() => {
                                                            addNewField()
                                                        }}
                                                    ></AddCircleOutline> :
                                                    <></>
                                                }
                                            </Grid>
                                        </>
                                    )

                                    )}
                                </Grid>
                            </Box>
                            <Box style={{display: 'flex', justifyContent: 'center', marginTop: '0.75rem'}}>
                                <Button style={buttonStyle}
                                    onClick={AddNewTemplate}
                                >Add</Button>
                            </Box>
                            <Box style={{display: 'flex', justifyContent: 'center', padding: '0.5rem'}}>
                                <Typography style={{...errorTextStyle, fontSize: '0.9rem'}}>{addApiError}</Typography>
                            </Box>
                            
                        </Paper>
                    </Box> :
                    <Box>
                        {apiError !== '' ? 
                            <Typography>{apiError}</Typography>
                            :
                            leadTemplates.length === 0 ?
                            <Typography>No Lead Templates.</Typography> :
                            <>
                                {leadTemplates.map((lead) => (

                                    <Grid container spacing={1} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #D9D9D9', padding: '0.5rem 0.2rem 0.2rem 0.2rem', marginTop: '0.1rem'}}>
                                        <Grid item xs={3} sm={3}>
                                            <Typography>{lead.title}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            {
                                                lead?.fields.map((field, index) => (
                                                    <Typography><Circle style={{fontSize: '0.5rem'}}/> {field}, </Typography>
                                                ))
                                            }
                                            
                                        </Grid>
                                        <Grid item xs={3} sm={3}>
                                            <Typography>{lead.createdByName}</Typography>
                                        </Grid>
                                    </Grid>
                                ))}
                            </>
                        }

                    </Box>
                }

            </DialogContent>

        </Dialog>
    </>
  )
}

export default LeadTemplates
